module.exports = __webpack_public_path__ + "static/img/ios_es.75069b1f.png";